import React from 'react';

import classnames from 'classnames';

import styles from 'css-module/components/ui/_Skeleton.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  width?: string | number;
  height?: string | number;
  animation?: 'pulse' | 'wave' | 'none';
}

const Skeleton = ({ className, width, height, animation = 'pulse', style, ...props }: Props) => {
  const skeletonStyle = {
    width,
    height,
    ...style,
  };

  return (
    <div
      {...props}
      className={classnames(styles.skeleton, className, {
        [styles[animation]]: true,
      })}
      style={skeletonStyle}
    />
  );
};

export default Skeleton;
